import { useContext } from "react";
import { ChaseLogicContext, IChaseLogicContext } from "../providers/chase-logic-provider";

export default function UseChaseProvider(): IChaseLogicContext {
    const getChaseLogicContext = useContext(ChaseLogicContext)!

    return getChaseLogicContext
}